import type { Middleware } from '@reduxjs/toolkit'
import { isRejectedWithValue } from '@reduxjs/toolkit'
import { ApplicationEvents } from 'share/enums/events'
import Emitter from 'utils/emitter'

export const apiErrorMiddleware: Middleware = () => next => action => {
  if (!isRejectedWithValue(action)) return next(action)

  if (action.payload?.status === 403) {
    Emitter.emit(ApplicationEvents.NAVIGATE_TO_NEXT_PAGE)
  }

  return next(action)
}
